import { reduxForm } from 'redux-form';

import OwnerMembershipForm from './OwnerMembershipForm';

export default reduxForm({ form: 'ownerMembershipForm' })(OwnerMembershipForm as any) as any;
